import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PresentPlayIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.5 3.33301C13.4998 2.87303 13.127 2.50018 12.667 2.5H3.33301C2.87303 2.50018 2.50018 2.87303 2.5 3.33301V12.667C2.50018 13.127 2.87303 13.4998 3.33301 13.5H12.667C13.127 13.4998 13.4998 13.127 13.5 12.667V3.33301ZM14.5 12.667C14.4998 13.6793 13.6793 14.4998 12.667 14.5H3.33301C2.32074 14.4998 1.50018 13.6793 1.5 12.667V3.33301C1.50018 2.32074 2.32074 1.50018 3.33301 1.5H12.667C13.6793 1.50018 14.4998 2.32074 14.5 3.33301V12.667Z"
      fill="currentColor"
    />
    <path
      d="M11.5 7.55489C11.8333 7.75151 11.8333 8.24307 11.5 8.4397L6.25 11.5365C5.91667 11.7332 5.5 11.4874 5.5 11.0941V4.90046C5.5 4.50721 5.91667 4.26143 6.25 4.45806L11.5 7.55489Z"
      fill="currentColor"
    />
  </svg>
);
